/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Coaches_AsideInputs */

const en_portal_coaches_aside = /** @type {(inputs: Portal_Coaches_AsideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live from the coaches' calendars. You don't need an account to see the open hours.`)
};

const pl_portal_coaches_aside = /** @type {(inputs: Portal_Coaches_AsideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Na żywo z kalendarzy trenerów. Nie musisz mieć konta, żeby zobaczyć wolne godziny.`)
};

/**
* | output |
* | --- |
* | "Live from the coaches' calendars. You don't need an account to see the open hours." |
*
* @param {Portal_Coaches_AsideInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_coaches_aside = /** @type {((inputs?: Portal_Coaches_AsideInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Coaches_AsideInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_coaches_aside(inputs)
	return en_portal_coaches_aside(inputs)
});